import { useState } from 'react';
import { DisplayOrganisationUser } from '../../types/core.type';
import { ColumnDef } from '../../types/table.type';
import Role from '../../types/enums';
import { wardAdminAccess } from '../../utils/authRoleWrap';
import InformationText from '../InformationText';
import SplitLayout from '../splitLayout';
import Table from '../table';
import RoleCell from './roleCell';

function OrgAdminPanel({ tableData, }: { tableData: DisplayOrganisationUser[]; }) {
  const [users, setUsers] = useState<DisplayOrganisationUser[]>(tableData);

  const handleRoleChanged = (email: string, newRole: Role) => {
    setUsers((prev) => prev.map((u) => (u.email === email ? { ...u, role: newRole } : u)));
  };

  const columns: ColumnDef<DisplayOrganisationUser>[] = [
    { key: 'lastName', header: 'Last Name', sortable: true },
    { key: 'firstName', header: 'First Name', sortable: true },
    {
      key: 'role',
      header: 'Role',
      sortable: true,
      render: (_value, row) => (
        <RoleCell user={row} onRoleChanged={handleRoleChanged} />
      ),
    },
    { key: 'email', header: 'Email', sortable: true },
  ];

  return (
    <SplitLayout leftWeight="md:w-4/12" rightWeight="md:w-8/12">
      <InformationText title="Your Team" subtitle="Edit user roles or archive users" />
      <Table
        data={users}
        columns={columns}
        title="Your Team"
      />
    </SplitLayout>
  );
}
const AdminDashboard = wardAdminAccess(OrgAdminPanel);

export default AdminDashboard;
